export { default } from "../../../collection/separate-items/[uid]/[pid]"
